import { Box, Typography } from "@mui/material";
import pageLoading from "../../_assets/images/sea-pro-loading.gif";
import LoaderBox from "./LoaderBox";

interface IProps {
  loading: boolean;
  showTitle?: boolean; //if not passed in default to false.
  hideImg?: boolean; //if not passed in default to true.
}
const pageLoader = ({ loading, showTitle, hideImg }: IProps) => {

  return loading ? (
    <div className="loading-indicator">
      <LoaderBox showTitle={showTitle ?? false} hideImg={hideImg ?? true} />
    </div>
  ) : null;
};
export default pageLoader;
